// extracted by mini-css-extract-plugin
module.exports = {"box":"InsuredInfo_box__1Dg9f"};